import React from "react";
import { Link } from "react-router-dom";

// One Billing navigation bar (PR #72 update, 2026-11-01). The same row of links sits at the top of
// every billing page, with the current page highlighted, so every page is one click from the Billing
// home and from each other (Caleb's walk: the pages had no way back).
// Static links only: no ids, no names, nothing fetched. The pages that show the bar already sit
// behind the server's billing gate (lib/billingAccess.js); the bar adds no access of its own.

export const BILLING_SECTIONS = [
  { key: "home", to: "/billing", label: "Billing home" },
  { key: "intake", to: "/billing/intake", label: "Network intake" },
  { key: "eob", to: "/billing/eob", label: "Money In (EOBs)" },
  { key: "wc", to: "/billing/wc", label: "WC claims" },
  { key: "wc-followup", to: "/billing/wc/followup", label: "WC follow-up" },
  { key: "pi", to: "/billing/pi", label: "PI liens" },
];

export default function BillingNav({ current }) {
  return (
    <nav aria-label="Billing" data-testid="billing-nav"
         className="mb-5 flex flex-wrap items-center gap-1 rounded-xl border border-slate-200 bg-white p-1 shadow-sm">
      {BILLING_SECTIONS.map((s) => {
        const on = s.key === current;
        return (
          <Link key={s.key} to={s.to} aria-current={on ? "page" : undefined} data-testid={`billing-nav-${s.key}`}
                className={`rounded-lg px-3 py-1.5 text-sm font-medium ${on ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"}`}>
            {s.label}
          </Link>
        );
      })}
    </nav>
  );
}
